const version = {
    "version": "2.1.0"
}

export default version